import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { defaultTo } from 'ramda';
import { useNavigate } from 'react-router-dom';

import { useClickTableDataLayer } from 'features/views/semaphore/hooks';
import { generateClickTableValuePair } from 'features/views/semaphore/utils';

export const SemaphoreTableRow = ({ rowTitle, data, handleClickData }) => {
	const navigate = useNavigate();

	const pushToClickTableDataLayer = useClickTableDataLayer();

	const handleClick = useCallback(
		(data) => () => {
			const clickedTableSection = generateClickTableValuePair(data);
			pushToClickTableDataLayer({ value: clickedTableSection })();
			navigate({
				pathname: '/semaphore',
				search: `?data=${data}`,
			});
		},
		[navigate, pushToClickTableDataLayer],
	);

	const generateColor = useCallback((index) => {
		switch (index) {
			case 0:
				return 'warning.main';
			case 1:
				return 'error.main';
			case 2:
				return 'grey.700';
		}
	}, []);

	return (
		<TableRow>
			<TableCell align="center" sx={{ borderBottom: 'unset' }}>
				<Typography variant="body1">{rowTitle}</Typography>
			</TableCell>
			{data &&
				data.map((item, i) => (
					<TableCell align="center" sx={{ fontWeight: 'bold', borderBottom: 'unset' }} key={i}>
						<Link
							underline="none"
							variant="body1"
							sx={{
								cursor: 'pointer',
								color: generateColor(i),
								fontWeight: 'bold',
							}}
							onClick={handleClick(handleClickData[i])}
						>
							{defaultTo(0)(item?.count)}
						</Link>
					</TableCell>
				))}
		</TableRow>
	);
};

SemaphoreTableRow.propTypes = {
	data: PropTypes.array,
	handleClickData: PropTypes.array,
	rowTitle: PropTypes.string,
};

export default SemaphoreTableRow;
